import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import moment from 'moment';
import {Version} from '../../shared/models/version';
import {SessionService} from './session.service';
import {CURRENT_PLATFORM} from './env.service';
import {Platform} from '../models/platform.enum';

export const VERSION_UI_CURRENT = '3.28';
export const VERSION_API_CURRENT = '4.0';
export const VERSION_RELOAD_DURATION_MS = 600000;

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  latestVersion: Version;
  newVersionAvailable: BehaviorSubject<moment.Moment> = new BehaviorSubject<moment.Moment>(null);


  constructor(
    private sessionService: SessionService,
  ) {
    this.latestVersion = new Version(VERSION_UI_CURRENT);
    console.info(`Motion Platform v2 (build version ${VERSION_UI_CURRENT})`);
  }


  /**
   * Receives a version number and determines whether it is greater than
   * VERSION_UI_CURRENT. If so, triggers the appropriate UI element to
   * inform user that a new version is available.
   *
   * @param latest {number} Latest known version number for the UI
   */
  setLatestVersion(latest: string) {
    // prevent running if mobile app
    if (CURRENT_PLATFORM !== Platform.WEB) {
      return;
    }

    this.latestVersion = new Version(latest);

    if (this.latestVersion.isGreaterThan(new Version(VERSION_UI_CURRENT))) {
      if (this.newVersionAvailable.getValue() === null) {
        if (this.sessionService.hasAuthenticated()) {
          this.newVersionAvailable.next(moment().add(VERSION_RELOAD_DURATION_MS, 'milliseconds'));
          console.info(`New build version (${this.latestVersion.versionString}) available. Refresh in ${VERSION_RELOAD_DURATION_MS} milliseconds.`);

          setTimeout(() => {
            window.location.reload();
          }, VERSION_RELOAD_DURATION_MS);
        } else {
          window.location.reload();
        }
      }
    }
  }
}
